module.exports = __webpack_public_path__ + "img/colchester.e5f2869b.jpg";